import {orientation} from "../../../../helpers/sqftHelper";
import point from "./point";

export const getAngle = (rotateAnglePart, angleValue) => {
  return (rotateAnglePart && rotateAnglePart.angleDirection === "right")
    ? (angleValue < 90) ? -angleValue : 90 - angleValue
    : (angleValue < 90) ? angleValue : angleValue - 90;
};

export const getRotationCentrePoint = (rotateAnglePart, angleValue, bottomLine, basePoint, secondaryPoint) => {
  let {
    basePointX, basePointX2, basePointY, basePointY2, baseOldX, baseOldY, baseOldX1, baseOldY1, widthDiff, rotated90_1, rotated90_2
  } = rotateAnglePart.baseConfiguration;

  void baseOldX; void baseOldY; void baseOldX1; void baseOldY1; void rotated90_1; void rotated90_2;
  let rotationCenterPoint;
  let line;
  let newDirection;
  widthDiff = Math.round(widthDiff);

  if (rotateAnglePart && rotateAnglePart.shapeType === "horseshoe" || rotateAnglePart && rotateAnglePart.shapeType === "wideangle") {
    if(angleValue < 90) {
      rotationCenterPoint = {
        x: basePointX2,
        y: basePointY2
      };
    } else {
      if(rotateAnglePart && rotateAnglePart.angleDirection === "right") {
        line = secondaryPoint.getParent();
        newDirection = line.getLineDirection().newDirection;

        switch (line.getOrientation()) {
          case orientation.HORIZONTAL:{
            if (newDirection === "east") { rotationCenterPoint = { x: basePointX + widthDiff, y: basePointY }}
            if (newDirection === "west") { rotationCenterPoint = { x: basePointX - widthDiff, y: basePointY }}
            break;
          }
          case orientation.VERTICAL:  {
            if (newDirection === "north") { rotationCenterPoint = { x: basePointX, y: basePointY - widthDiff }}
            if (newDirection === "south") { rotationCenterPoint = { x: basePointX, y: basePointY + widthDiff }}
            break;
          }
          default:
            break;
        }
      } else {
        line = basePoint.getParent();
        newDirection = line.getLineDirection().newDirection;

        switch (line.getOrientation()) {
          case orientation.HORIZONTAL:{
            if (newDirection === "east") { rotationCenterPoint = { x: basePointX + widthDiff, y: basePointY }}
            if (newDirection === "west") { rotationCenterPoint = { x: basePointX - widthDiff, y: basePointY }}
            break;
          }
          case orientation.VERTICAL:  {
            if (newDirection === "north") { rotationCenterPoint = { x: basePointX, y: basePointY - widthDiff }}
            if (newDirection === "south") { rotationCenterPoint = { x: basePointX, y: basePointY + widthDiff }}
            break;
          }
          default:
            break;
        }
      }
    }
  }

  if (rotationCenterPoint === undefined) {
    var tempLinePointFrom = new point(line.from.x, line.from.y);
    var tempLinePointTo = new point(line.to.x, line.to.y);
    tempLinePointFrom.init(bottomLine);
    tempLinePointFrom.layout = 'white-circle';

    tempLinePointTo.init(bottomLine);
    tempLinePointTo.layout = 'white-circle';

    rotationCenterPoint = getRotationCentrePointByBottomLine(rotateAnglePart, angleValue, bottomLine);
  }

  return rotationCenterPoint
};

export const getRotationCentrePointByBottomLine = (rotateAnglePart, angleValue, bottomLine) => {
  const {
    basePointX, basePointX2, basePointY, basePointY2, baseOldX, baseOldY, baseOldX1, baseOldY1, widthDiff, rotated90_1, rotated90_2
  } = rotateAnglePart.baseConfiguration;
  void baseOldX; void baseOldY; void baseOldX1; void baseOldY1; void rotated90_1; void rotated90_2;

  let rotationCenterPoint;
  if (rotateAnglePart && rotateAnglePart.shapeType === "wideangle") {
    rotationCenterPoint = {
      x: angleValue < 90 ? basePointX2 : (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? basePointX - widthDiff : basePointX + widthDiff,
      y: angleValue < 90 ? basePointY2 : basePointY,
    };
  } else if (rotateAnglePart && rotateAnglePart.shapeType === "horseshoe") {
    if(angleValue < 90) {
      rotationCenterPoint = {
        x: basePointX2,
        y: basePointY2
      };
    } else {
      if(rotateAnglePart && rotateAnglePart.angleDirection === "right") {
        switch (bottomLine.getOrientation()) {
          case orientation.HORIZONTAL:{ rotationCenterPoint = { x: basePointX, y: basePointY }; break;}
          case orientation.VERTICAL:  { rotationCenterPoint = { x: basePointX, y: basePointY }; break;}
          case orientation.SOUTHEAST: { rotationCenterPoint = { x: basePointX - widthDiff, y: basePointY}; break;}
          case orientation.NORTHEAST: { rotationCenterPoint = { x: basePointX, y: basePointY + widthDiff }; break; }
          case orientation.SOUTHWEST: { rotationCenterPoint = { x: basePointX, y: basePointY - widthDiff}; break; }
          case orientation.NORTHWEST: { rotationCenterPoint = { x: basePointX + widthDiff, y: basePointY }; break; }
          default:
            break;
        }
      } else {
        switch (bottomLine.getOrientation()) {
          case orientation.HORIZONTAL: { rotationCenterPoint = { x: basePointX, y: basePointY }; break; }
          case orientation.VERTICAL: { rotationCenterPoint = { x: basePointX, y: basePointY }; break; }
          case orientation.SOUTHEAST: { rotationCenterPoint = { x: basePointX, y: basePointY + widthDiff}; break; }
          case orientation.NORTHEAST: { rotationCenterPoint = { x: basePointX + widthDiff, y: basePointY}; break; }
          case orientation.SOUTHWEST: { rotationCenterPoint = { x: basePointX - widthDiff, y: basePointY}; break; }
          case orientation.NORTHWEST: { rotationCenterPoint = { x: basePointX, y: basePointY - widthDiff}; break; }
          default:
            break;
        }
      }
    }
  }

  return rotationCenterPoint
};
